/* eslint-disable valid-typeof */

import { useQueries } from '@tanstack/react-query';
declare global {
  interface Window {
    config: {
      LANGUAGE: string;
      LICENSE: string;
      BASE_PATH: string;
      SESSION_ID?: string;
      ACCESS_BONUS?: Number;
      ACCESS_PHYSICAL_PRODUCT?: Number;
    };
    showLoginBox: () => void;
  }
}
/** Adds localeId and licenseId to filter passed as props */
function useLocaleQueryFilter<T>(filter = {} as T) {
  let lang = 'FR';
  let license = 'FR';
  if (typeof window !== undefined && typeof window.config === 'object') {
    lang = window.config?.LANGUAGE ?? 'FR';
    license = window.config?.LICENSE ?? 'FR';
  }

  // console.log('[DEBUG] window.config', {
  //   lang,
  //   license,
  // });
  const [{ data: licenseId }, { data: localeId }] = useQueries({
    queries: [
      {
        queryKey: ['license', { value: license }],
        enabled: !!license,
        staleTime: 1000000,
      },
      {
        queryKey: ['language', { value: lang }],
        enabled: !!lang,
        staleTime: 1000000,
      },
    ],
  });
  let response = {
    localeId: localeId as number,
    licenseId: licenseId as number,
  };

  return { ...response, ...filter };
}

export default useLocaleQueryFilter;
